import { API_LOAN_VALIDATION, API_LOAN_VALIDATION_LOG } from 'config'
import Api from 'services/api'

export const getLoanValidation = () => {
  return Api.get(API_LOAN_VALIDATION)
}

export const getLoanValidationLogs = (key: string, type: string = 'loan', index: number = -1) => {
  return Api.get(API_LOAN_VALIDATION_LOG, {}, { key, type, index })
}

export const updateLoanValidation = (data: Record<string, any>) => {
  return Api.post(API_LOAN_VALIDATION, data)
}
